export default () => ({
  institutionConfiguration : {},
  topicTypes               : {},
  topicTypesRequest        : null,
  topicTypesIcons          : {},
  topicTypesColors         : {},
  topicTypesNames          : {}
});
